import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Masthead } from "@/components/site/Masthead";
import { Footer } from "@/components/site/Footer";
import { api } from "@/lib/api";

const lastTrack = { path: null, at: 0 };

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const now = Date.now();
    if (lastTrack.path === pathname && now - lastTrack.at < 1500) return;
    Object.assign(lastTrack, { path: pathname, at: now });
    const entry = !sessionStorage.getItem("ukd_entry");
    sessionStorage.setItem("ukd_entry", "1");
    const utm = new URLSearchParams(window.location.search).get("utm_source") || "";
    api.post("/track", { path: pathname, entry, referrer: entry ? document.referrer : "", utm_source: entry ? utm : "" }).catch(() => {});
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <Masthead />
      <main className="flex-1 w-full max-w-5xl mx-auto px-5 sm:px-8">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
